// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"4afdea22","245":"8d57df4e","558":"90a0e995"}[chunkId] + ".chunk.css";
};